<dx-scroll-view
  height="100%"
  [useNative]="false"
  [showScrollbar]="'always'"
  *var="Entity.conferenceExcursionsInfo | hasPermission: EntityPermissionActivityKeys.write | async as canWrite"
>
  <ag-crm-excursion-modal
    #conferenceModalRef
    [calendarDisplayDate]="conference?.[ConferenceKeys.startDate]"
  ></ag-crm-excursion-modal>

  <dx-form
    [(formData)]="conference"
    labelMode="floating"
    [validationGroup]="validationGroup"
    [readOnly]="isReadonlyMode || !canWrite"
  >
    <dxi-item itemType="group" [colCount]="2">
      <dxi-item
        [dataField]="ConferenceKeys.excursionsBudget"
        editorType="dxNumberBox"
        [label]="{ text: titleList[ConferenceKeys.excursionsBudget] }"
        [editorOptions]="{
          format: { type: 'currency', currency: 'USD', precision: 2 },
          min: 0,
          name: ConferenceKeys.excursionsBudget,
        }"
      >
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item
        [dataField]="ConferenceKeys.excursionsBookingTime"
        editorType="dxNumberBox"
        [label]="{ text: 'Seat Booking Time' }"
        [editorOptions]="{ format: '#', min: 0 }"
      >
      </dxi-item>
    </dxi-item>

    <dxi-item>
      <div *dxTemplate>
        <ng-content
          *ngTemplateOutlet="
            excursionsGrid;
            context: {
              dataSource: conference?.[ConferenceKeys.excursions],
              title: 'Activities',
              path: ConferenceKeys.excursions,
            }
          "
        ></ng-content>
      </div>
    </dxi-item>

    @if (conference?.[ConferenceKeys.isChairmanExtensionEnabled]) {
      <dxi-item itemType="group" [colCount]="2" cssClass="mt-4">
        <dxi-item
          [dataField]="
            [ConferenceKeys.chairmanExtensionConfiguration, ChairmanExtensionConfigurationKeys.excursionsBudget] | path
          "
          editorType="dxNumberBox"
          [label]="{ text: 'Chairman Ext. Excursions Budget' }"
          [editorOptions]="{
            format: { type: 'currency', currency: 'USD', precision: 2 },
            min: 0,
            name: ConferenceKeys.excursionsBudget,
          }"
        >
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
      </dxi-item>

      <dxi-item>
        <div *dxTemplate>
          <ng-content
            *ngTemplateOutlet="
              excursionsGrid;
              context: {
                dataSource:
                  conference?.[ConferenceKeys.chairmanExtensionConfiguration]?.[
                    ChairmanExtensionConfigurationKeys.excursions
                  ],
                title: 'Chairman Ext. Activities',
                path:
                  [ConferenceKeys.chairmanExtensionConfiguration, ChairmanExtensionConfigurationKeys.excursions] | path,
              }
            "
          ></ng-content>
        </div>
      </dxi-item>
    }
  </dx-form>

  <ng-template #excursionsGrid let-dataSource="dataSource" let-title="title" let-path="path">
    <dx-data-grid
      #excursionsGridTmp
      [dataSource]="dataSource"
      [showRowLines]="true"
      [rowAlternationEnabled]="true"
      (onRowRemoving)="onRowRemoving($event, dataSource, path)"
      height="100%"
    >
      <dxo-editing
        mode="row"
        [useIcons]="true"
        [allowUpdating]="!isReadonlyMode && canWrite"
        [allowDeleting]="
          !isReadonlyMode &&
          (Entity.conferenceExcursionsInfo | hasPermission: EntityPermissionActivityKeys.delete | async)
        "
        [allowAdding]="
          !isReadonlyMode &&
          (Entity.conferenceExcursionsInfo | hasPermission: EntityPermissionActivityKeys.create | async)
        "
      ></dxo-editing>

      <dxo-toolbar>
        <dxi-item location="before">
          <span *dxTemplate class="dx-form-group-caption">{{ title }}</span>
        </dxi-item>

        <dxi-item
          location="after"
          widget="dxButton"
          [options]="{
            icon: 'plus',
            onClick: ExcursionModalAction.create | conferenceExcursionModalAction: conference : path,
          }"
          *ngIf="
            !isReadonlyMode &&
            (Entity.conferenceExcursionsInfo | hasPermission: EntityPermissionActivityKeys.create | async)
          "
        ></dxi-item>
      </dxo-toolbar>

      <dxi-column [dataField]="ExcursionKeys.name" caption="Activity" [alignment]="'left'"></dxi-column>

      <dxi-column
        [dataField]="ExcursionKeys.cost"
        caption="Cost"
        [dataType]="'number'"
        [format]="DX_USD_CURRENCY_FORMAT"
      ></dxi-column>

      <dxi-column
        [dataField]="ExcursionKeys.date"
        caption="Activity Date"
        [allowEditing]="false"
        [dataType]="'date'"
        [sortOrder]="'desc'"
        [format]="dateFormat"
        [sortIndex]="1"
        [groupIndex]="0"
        width="250"
      ></dxi-column>

      <dxi-column type="buttons">
        <dxi-button
          [icon]="canWrite ? 'edit' : 'agi-eye'"
          [hint]="canWrite ? 'Edit' : 'View'"
          [onClick]="
            (canWrite ? ExcursionModalAction.edit : ExcursionModalAction.view)
              | conferenceExcursionModalAction: conference : path
          "
        >
        </dxi-button>

        <dxi-button
          icon="copy"
          [onClick]="ExcursionModalAction.copy | conferenceExcursionModalAction: conference : path"
          [visible]="Entity.conferenceExcursionsInfo | hasPermission: EntityPermissionActivityKeys.create | async"
        ></dxi-button>

        <dxi-button name="delete"></dxi-button>
      </dxi-column>
    </dx-data-grid>
  </ng-template>
</dx-scroll-view>
